import styled from 'styled-components';
import SeatingAreaSvg from '../../assets/amenities/seating-area.svg';

const SeatingAreaIcon = styled(SeatingAreaSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default SeatingAreaIcon;
